export const locale = {
  lang: 'zh1',
  data: {
    'ALERTS':{
      'OK':'OK'
    },
    'FOCUS':{
      'GRUPOS':{
        'ADMIN': '集團經理',
        'CREAR': '創建組',
        'EDITAR': '修改組',
        'APLICAR': '應用',
        'NAME':'組的名字',
        'DESCRIPCION': '描述',
        'FILTROS': '篩選器',
        'ACCION': '動作',
        'EDIT': '編輯',
        'DELETE': '刪除'
      },
      'CREAR': {
        'DATO': '組數據',
        'NAME': '組的名字',
        'DESCRIPCION': '團體簡介',
        'FILTROS': '篩選器',
        'FILSELEC': '選定的過濾器',
        'COUNTRY': '國家',
        'CARGO': '位置或功能',
        'ANTIG': '古代',
      },
      'REACTIVOS': {
        'SIN': '您尚未選擇語句',
        'STEPS': {
          '1': {
              'TITULO': '報表選擇',
              'DISPONIBLES': '可用模板：',
              'LISTADO': {
                'TITULO': '選擇要構建調查的列表的語句',
                'SUBTITULO': '從列表中選擇一個模板以顯示其語句列表',
                'PICKEDTITU': '模板的語句列表：',
                'PICKEDTOT': '可用語句：',
                'PICKEDNUM': '選擇的陳述：',
              }
          },
          '2': {
              'TITULO': '翻譯'
          },
          '3': {
              'TITULO': 'Previsualización',
              'TEXTOS': {
                'es': {
                  'EMPRESA': 'Responde pensando en tu empresa y en todos los líderes',
                  'AREA': 'Responde pensando en tu área de trabajo y tu líder directo',
                  'BOTONES': {
                    '0': 'Casi siempre es falso',
                    '1': 'Frecuentemente es falso',
                    '2': 'A veces es falso / A veces es verdad',
                    '3': 'Frecuentemente es verdad',
                    '4': 'Casi siempre es verdad'
                  }
                },
                'en': {
                  'EMPRESA': 'Organization Perspective',
                  'AREA': 'Workgroup Perspective',
                  'BOTONES': {
                    '0': 'It is almost always false',
                    '1': 'It is often false',
                    '2': 'Sometimes it´s fake / Sometimes it´s true',
                    '3': 'It is often true',
                    '4': 'It is almost always true'
                  }
                },
                'pt': {
                  'EMPRESA': 'Perspectiva da organização',
                  'AREA': 'Perspectiva do grupo de trabalho',
                  'BOTONES': {
                    '0': 'Quase sempre é falso',
                    '1': 'É frequentemente falso',
                    '2': 'Às vezes é falso / às vezes é verdade',
                    '3': 'É frequentemente verdade',
                    '4': 'Quase sempre é verdade'
                  }
                },
              }
            }
        }
      }
    },
    'CERTIFICAR': {
      'IDIOMAS': {
        'ELEGIR': '選擇',
        'STATUS': {
          'PEND': '完成此步驟',
          'DONE': '此步驟已完成'
        },
        'MENSAJES':{
          'ADDLANG': '你選擇',
          'NOADITIONAL': '您選擇不設置其他語言',
          'ERRORADD': '選擇語言時發生錯誤 ',
          'LANGDEL': '您删除了 ',
          'NOADITIONALDEL': '您取消了不設置其他語言的選項s',
          'ERRORDEL': '刪除語言時發生錯誤 ',
          'MAINPICKED': '您已選擇調研的主要語言。<br> <br>若要更改，請刪除所選的語言並選擇另一個語言選項。'
        },
        'CARD1': {
          'TITULO': '主要語言',
          'ACCION': {
            'PRE': '您尚未選擇主要語言',
            'POST': '您選擇了語言'
          },
          'MODAL': {
            'TITULO': '選擇主要語言',
            'ACCION': '調查的主要使用哪種語言？',
            'PLACELISTA': '選擇語言',
            'BOTONES': {
              'BACK': '回上頁',
              'OK': '完成'
            }
          }
        },
        'CARD2': {
          'TITULO': '其他語言',
          'ACCION': {
            'PRE': '您尚未選擇其他語言',
            'SINADIC': '調研將不會有其他語言',
            'POST': '您選擇了以下語言'
          },
          'MODAL': {
            'TITULO': '選擇其他語言',
            'ACCION': '您想添加哪些語言？',
            'BOTONES': {
              'BACK': '回上頁',
              'OK': '完成'
            }
          }
        }
      },
      'NPS': {
        'CONFIGURE_QUESTION': '按此處顯示NPS',
        'ADD': '建立陳述',
        'QUESTIONUPDATEDOK': 'NPS更新成功',
        'STATUS': {
          'PEND': '完成此步驟',
          'DONE': '此步驟已完成'
        },
        'TABS': {
          'TAB1': 'NPS',
          'TAB2': '翻譯',
          'TAB3': '預習',
        }
      },

      'REACTIVOS': {
        'CONFIGURE_QUESTION': '單擊此處配置語句',
        'ADD': '建立陳述',
        'QUESTIONUPDATEDOK': '聲明已成功更新',
        'STATUS': {
          'PEND': '完成此步驟',
          'DONE': '此步驟已完成'
        },
        'TABS': {
          'TAB1': '反應性',
          'TAB2': '翻譯',
          'TAB3': '預習',
        }
      },
      'CONTROL': {
        'CONFIGURE_QUESTION': '單擊此處顯示控制問題',
        'ADD': '建立陳述',
        'QUESTIONUPDATEDOK': '控制問題已成功更新',
        'STATUS': {
          'PEND': '完成此步驟',

          'DONE': '此步驟已完成'
        },
        'TABS': {
          'TAB1': '控制問題',
          'TAB2': '翻譯',
          'TAB3': '預習',
        }
      },
      'DEMOGRAFICOS': {
        'NOINFO':'無資料',
        'TAB1': '人口統計',
        'TAB2': '翻譯',
        'TAB3': '預習',
        'COMPLETAR_PASO': '完成步驟',
        'PASO_COMPLETADO': '步驟完成',
        'SELECT': '選擇一個選項',
        'BTN_DEMOGRAFICOS': '接受',
        'OPTION_SURVEY': '調查',
        'OPTION_EXCEL': 'Excel',
        'OPTION_AMBOS': '都',
        'CLAVE': '关键',
        'RESPONSE_NOT_ADDED': '您无法为未解决的问题添加答案',
        'CONFIGURE_QUESTION': '點擊此處顯示問題',
        'QUESTION': '題',
        'OPCIONES_RESPUESTA': '回應選項',
        'STATUS': {
          'PEND': '完成此步驟',
          'DONE': '此步驟已完成'
        },
        'EXPANSION':{
          'Work Responsability' : '工作職責',
          'Trust Level' : '信任級別',
          'Innovation' : '創新',
          'Disabilities' : '殘疾',
          'Ethnic Group' : '民族團體',
          'Personal Responsabilities' : '個人責任',
          'Gender' : '性別',
          'Work Location' : '工作地點',
          'Travel' : '旅行',
          'Living Location' : '居住地點',
          'Marital Status' : '婚姻狀況',
          'Home Type' : '房屋類型',
          'Home Location' : '家庭位置',
          'Home Status' : '家庭狀態',
          'Transport' : '運輸',
          'Sports' : '體育',
          'Weight' : '重量',
          'Sleep' : '睡眠',
          'Home Office' : '內政部',
          'Languages' : '語言',
          'Work Experience' : '工作經驗',
          'Social Networks' : '社交網絡',
          'Employ Opportunities' : '就業機會',
          'Inspiration' : '靈感',
          'Meetings' : '會議',
          'Tenure' : '任期',
          'Clave': '關鍵',
          'Ege': '代',
          'Work Status': '工作狀態',
          'Education': '教育',
          'Hierarchical Level': '等級級別',
          'Confidence Decisions': '信心決策',
          'Work Innovation': '工作創新',
          'Belong': '屬於',
          'Converse Performance': '效果相反',
          'Work Years':'工作年限',
          'Generation':'代',
          'Confidence In Decisions': '決策信心',
          'Develop New Things': '開發新事物',
          'Reason To Stay':'留下的理由',
          'Age':'年齡',
          'Type Of Job':'工作類型',
          'Minoritate':'少數派',
          'Sindicat':'辛迪卡特',
          //TURQUIA//
          'Confidence':'置信度',
          'Opportunities':'商機',
          'Managerial Level':'管理級別',
          'Years Of Service':'服務年限',
          'Ethnic':'民族',
          //CAYC//
          'Hierarchical Leve':'層級',
          'Disability':'失能',
          'Responsibility':'責任',
          'LGBT':'LGBT',
          //ESPAÑA
          'Recommendation':'建議',
          'Seniority':'資歷',
          'Contracting modality':'承包方式',
          'Working':'加工',

        }
      },
      'FORALL': {
        'MSJ_PRACTICEREGISTERED': '練習已成功保存',
        'MSJ_DESCRIPTIONREGISTERED': '說明已成功保存',
        ////traducir
        'MSJ_TRANSLATEREGISTERED': '實踐翻譯成功',
        'MSJ_DESCRIPTIONTRANSLATED': '說明已成功翻譯',
        'QUESTIONUPDATEDOK': '問題已成功更新',
        'QUESTIONUPDATEDFAIL': '錯誤，請插入有效問題',
        'RESPONSEUPDATEDOK': '回復成功更新',
        'RESPONSEUPDATEDFAIL': '錯誤，請插入有效的回复文字',
        'TRANSLATEDOK': '問題翻譯成功保存',
        'INSERTTRANSLATE': '請插入翻譯',
        'OPTIONTRANSLATED': '選項翻譯成功保存',
        'INSERTOPTIONTRANSLATE': '請插入翻譯',
        'MJS_SELECTOPTION': '請選擇一個選項',
        'MJS_OPTIONADDED': '受眾特徵已正確添加',
        'OPTIONDELETED': '受眾特徵已成功刪除',
        'RESPONSEOPTIONDELETED': '響應成功消除',
        'DEMOGRAPHICEXIST': '所選的受眾特徵已存在',
        'AGREGADEMOGRAFICO': '選擇添加更多的受眾特徵',
        'MSJ_PRACTICEREQUIRED': '需要實踐!',
        'MSJ_DESCRIPTIONREQUIRED': '說明為必填項!',
        'CARGANDO_PRACTICA': '正在保存，請稍候...',
        'CARGANDO_DESCRIPCION': '保存描述，請稍候...',
        'ACTUALIZAR_OPCION': '正在更新回應，請稍候...',
        'REVISANDO_PRACTICAS': '檢查做法，請稍候...',


        'SELECCIONE': '選擇一種語言',
        'IDIOMAS_NOT_SELECTED': '未選擇翻譯其他語言',
        'TRANSLATE_NOT': '您必須至少寫下一種做法的名稱及其描述',
        'PLACEHOLDER': '語言',
        'DESC_TRANSLATE': '輸入描述',
        'DESC_TRANSLATE_DEMO':'輸入答案的譯文',
        'DESC_TRANSLATE_FORALL':'輸入描述的翻譯內容',

        'PRACTICE_TRANSLATE_REACTIVOS': '輸入報表的翻譯',
        'PRACTICE_TRANSLATE_ABIERTAS': '輸入報表的翻譯',
        'PRACTICE_TRANSLATE_FORALL': '輸入練習翻譯',
        'PRACTICE_TRANSLATE_DEMO': '輸入受眾特徵的翻譯',



        'IDIOMAS': {
          'Native': 'Nativo',
          'es': 'Español',
          'zh1': 'Chino Tradicional',
          'zh2': 'Chino Simplificado',
          'pt': 'Portugués',
          'en': 'Inglés'
        },
        'RESPUESTAS': {
          'Native': 'Nativo',
          'es':{'si': 'SÍ',
          'no':'NO',
          'casifalso':'Casi siempre es falso',
          'false': 'Frecuentemente es falso',
          'avecesfalse': 'A veces es falso / A veces es verdad',
          'casiverdad': 'Frecuentemente es verdad',
          'verdad': 'Casi siempre es verdad'},
          'zh1':{'si': '有','no':'沒有',
          'casifalso':'從來不是這樣',
          'false': '經常不是這樣',
          'avecesfalse': '有時是有時不是',
          'casiverdad': '經常是這樣',
          'verdad': '總是這樣'},
          'zh2':{'si': '有','no':'没有',
          'casifalso':'从来不是这样',
          'false': '经常不是这样',
          'avecesfalse': '有时是有时不是',
          'casiverdad': '经常是这样',
          'verdad': '总是这样'},
          'pt':{'si': 'SI','no':'não',
          'casifalso':'Casi siempre es falso',
          'false': 'Freqüentemente é falso',
          'avecesfalse': 'A veces es falso / A veces es verdad',
          'casiverdad': 'Freqüentemente es verdad',
          'verdad': 'Casi siempre es verdad'},
          'en':{'si': 'YES','no':'NO',
          'casifalso':'It is almost always false',
          'false': 'It is often false',
          'avecesfalse': 'Sometimes it´s fake / Sometimes it´s true',
          'casiverdad': 'It is often true',
          'verdad': 'It is almost always true'},
          'tr':{'si': 'Evet','no':'HAYIR',
          'casifalso':'Neredeyse her zaman yanlış',
          'false': 'Sık sık yanlış',
          'avecesfalse': 'Bazen doğru olmayan / bazen doğru',
          'casiverdad': 'Genellikle doğru',
          'verdad': 'Neredeyse her zaman doğru'},
          'jp':{'si': 'はい','no':'番号',
          'casifalso':'ほとんど常に当てはまらない',
          'false': 'しばしば当てはまらない',
          'avecesfalse': '時には当てはまらない／時には当てはまる',
          'casiverdad': 'しばしば当てはまる',
          'verdad': 'ほとんど常に当てはまる'}
        },
        'STATUS': {
          'PEND': '完成步驟',
          'DONE': '此步驟已完成'
        },
        'TABLA': {
          'TITULOS': {
            'DEFAULT': '主要語言',
            'TRADUCCION': '翻譯',
            'PREVIEW': '預覽'
          },
          'ENCABEZADOS': {
            'PRACT': '實踐',
            'DESCR': '描述',
            'STT1': '陳述1',
            'STT2': '陳述2',
            'LANG': '語言'
          },
          'INPUTS': {
            'PRACT': '輸入實踐內容',
            'DESCR': '輸入描述'
          }
        }
      },
      'ABIERTAS': {
        'STATUS': {
          'PEND': '完成此步驟',
          'DONE': '此步驟已完成'
        },
        'TABS': {
          'TAB1': '公開問題',
          'TAB2': '翻譯',
          'TAB3': '預習',
        }
      },
      'ADICIONALES': {
        'FOCUS':{
          'ENVIO-AUTORIZACION':'已發送給授權',
          'AUTORIZACION-OK':'您的調查已被授權，請繼續執行此步驟',

        },
        'STATUS': {
          'PEND': '完成步驟',
          'DONE': '此步驟已完成'
        },
        'TABS': {
          'QUESTIONS': '其他問題',
          'TRANSLATE': '翻譯',
          'PREVIEW': '預覽'
        },
        'PREGUNTAS':{
          'STATUS': {
            'SIN': '您尚未新增任何其他問題',
            'CON': '問題已新增',
            'NOADICIONALES': '您選擇不新增其他問題',
            'CANCELNOADIC': '您取消了不新增其他問題的選項',
            'ERROR': '操作發生錯誤'
          },
          'ACCIONES': {
            'ADD': '新增問題',
            'SIN': '調研將不設有其他問題'
          },
          'WIZARD': {
            'NEW': '新問題',
            'TIPOTITU': '單擊此處以配置其他問題',
            'TIPO': {
              'OPEN': '開放式問題',
              'UNI': '單選題',
              'MULT': '多項選擇題',
              'MULTLIKERT3-1': '關於3李克特量表的問題',
              'MULTLIKERT5-1': '關於5李克特量表的問題',
              'MULTLIKERT-MUL': '關於李克特量表的問題倍數',
            },
            'FORM': {
              'TIPO': '問題類型',
              'TOOLTIP': {
                'REMOVE': '刪除此問題'
              },
              'MENSAJES': {
                'BORRAR': '您是否要刪除此附加問題？',
                'PREG_OK': '問題已成功儲存',
                'PREG_ERR': '儲存問題時發生錯誤',
                'PREG_MOD_OK': '問題修改成功',
                'PREG_MOD_ERR': '修改問題時發生錯誤',
                'OPC_OK': '答案選項已成功保存',
                'OPC_ERR': '儲存答案選項時發生錯誤',
                'OPC_MOD_OK': '答案選項修改成功',
                'OPC_MOD_ERR': '修改答案選項時發生錯誤',
                'PREG_DEL_OK': '問題已成功刪除',
                'PREG_DEL_ERR': '刪除問題時發生錯誤',
                'OPC_DEL_OK': '答案選項已成功刪除',
                'OPC_DEL_ERR': '刪除答案選項時發生錯誤'
              },
              'BOTONES':{
                'SI': '是',
                'NO': '否'
              }
            },
            'ABIERTA': {
              'TITULO': '新開放式問題',
              'ACCION': '輸入問題內容',
              'ERROR': '您尚未輸入問題內容'
            },
            'MULTI':{
              'TITULOSING': '新單選題',
              'TITULOMULT': '新多選項問題',
              'TITULOLIKERT3': '李克特量表的新問題：3',
              'TITULOLIKERT5': '李克特量表的新問題：5',
              'TITULOLIKERTSIMPLE': '新的簡單李克特量表問題',
              'ACCION': '輸入問題內容',
              'ERROR': '您尚未輸入問題內容',
              'MENSAJES': {
                'BORRAR': '您要刪除此答案選項嗎？',
                'SINPREG': '在輸入問題內容前，您無法加入任何選項',
                'SINANTE': '您必須先輸入上一個答案選項文本才能輸入此答案選項文本',
                'WARN-2-1':'您只能輸入2個答案選項',
                'WARN-3-1':'您只能輸入3個答案選項',
                'WARN-5-1':'您只能輸入5個答案選項',
                'WARN-NO-NUMBER': '您只能輸入數字',
                'ETIQUET-VALOR':'值',

              },
              'OPCIONES': {
                'TITU': '答案選項',
                'INPUT': {
                  'TITU': '答案選項',
                  'ERROR': '您尚未輸入答案選項內容'
                }
              },
              'TOOLTIP': {
                'ADD': '添加答案選項',
                'MOVE': '移動答案選項',
                'REMOVE': '刪除此答案選項'
              }
            }
          }
        },
        'TRADUCCIONES': {
          'TITULO': '選擇一種語言以開始輸入翻譯文本',
          'TITULOALTERNO': '您沒有在“語言”部分中選擇任何其他語言',
          'NOTYET': '翻譯尚未完成',
          'MAIN': '主要語言',
          'INPUT': {
            'NEW': '輸入問題翻譯',
            'ERROR': '尚未輸入問題翻譯！',
            'NEWOPC': '輸入答案選項翻譯',
            'ERROROPC': '您尚未輸入答案選項翻譯！'
          },
          'MENSAJES': {
            'PREG_OK': '翻譯內容儲存成功',
            'PREG_ERR': '儲存翻譯內容時發生錯誤',
            'PREG_MOD_OK': '翻譯內容已正確更新',
            'PREG_MOD_ERR': '更新翻譯內容時發生錯誤',
            'OPC_NOPREG': '設置問題內容前，無法保存選項的翻譯',
            'OPC_OK': '翻譯內容儲存成功',
            'OPC_ERR': '保存翻譯內容時發生錯誤',
            'OPC_MOD_OK': '翻譯內容已成功更新',
            'OPC_MOD_ERR': '更新翻譯內容時發生錯誤',


            'TRADUC_PREGUNT':'問題的翻譯內容已保存',
            'TRADUC_MOD_PREGUNT':'問題的翻譯正在更新',
            'TRADUC_OPC':'選項的翻譯被保存',
            'TRADUC_MOD_OPC':'選項的翻譯正在更新',
            'VALOR_OK':'該選項的值已正確保存',
            'VALOR_MOD_OK':'該選項的值已正確更新',
          },
          'COMPLETE': '翻譯完成'
        },
        'PREVIEW': {
          'TITULO': '選擇語言以顯示其他問題的翻譯',
          'SINPREV': '所選語言沒有翻譯內容',
          'LOADING': '資料加載中',
          'INPUT': {
            'RESPABIERTA': '填寫答案',
            'ERRORABIERTA': '您尚未填寫答案！',
            'ELIGELANG': '選擇語言'
          },
          'HELP': {
            'SINGLE': '您只能在此問題中選擇一個選項',
            'MULTI': '您可以在此問題中選擇多個選項',
            'FALTA': '尚未輸入翻譯文字！'
          }
        }
      },
      'COLABORADORES': {
        'STATUS': {
          'PEND': '完成此步驟',
          'DONE': '此步驟已完成'
        },
        'STATUSBAR': {
          'NOBD': '您尚未加載協作者數據庫',
          'PROCES': '協作者數據庫尚未存儲',
          'ERROR': '在加載的文件中發現錯誤',
          'OK': '協作者數據庫已正確存儲'
        },
        'CARD_BD': {
          'TITULO': '信息',
          'NUMCOLABS': '合作者數量',
          'FECHA': '上次上傳日期: ',
          'TITULO_PRE': '上傳記錄:',
          'TITULO_PRE_2': '使用者',
          'ACCIONES': '動作',
          'WANNADO': '你想讓我做什麼？',
          'BOTONES': {
            'DESCARGA': '下載合作者數據庫',
            'ELIMINA': '刪除合作者數據庫',
            'VER': '查看參加者清單'
          }
        },
        'CARD_NOBD': {
          'TITULO': '請按照以下步驟將您的合作者信息上傳到CulturalGO',
          'PASOS': {
            '1': '下載合作者數據庫模板',
            '2': '根據提供的列，用合作者信息填充模板',
            '3': '上載具有您的協作者信息的文件'
          },
          'TOOLTIP': '該文件包含數據驗證宏',
          'FILE': '協作者列表模板文件'
        },
        'CARD_NOERR': {
          'TITULO': '信息',
          'NUMCOLABS': '加載文件中的協作者數量',
          'FILENAME': '文件名',
          'GUARDAR': '您要存儲此信息嗎？',
          'BOTONES': {
            'SI': '是',
            'NO': '沒有'
          }
        },
        'CARD_ERRFND': {
          'TITULO': '信息',
          'ROWS_OK': '正確的行數',
          'ROWS_NOTOK': '有錯誤的行數',
          'MOREINFO': '*詳細的錯誤列表如下所示',
          'FILENAME': '文件名',
          'GUARDAR': '加載的信息無法存儲',
          'DELETE': '刪除文件'
        },
        'CARD_ERRLIST': {
          'TITULO': {
            '1': '有錯誤的行： ',
            '2': '發現的總錯誤數： '
          },
          'INFO': {
            'ROW': '行 ',
            'ERRNUM': '錯誤數量： ',
            'SHOW': '單擊此處顯示此行錯誤'
          },
          'DETALLE': {
            'TIPO': '錯誤類型',
            'DESCR': '描述',
            'COLUMNA': '柱',
            'DATO': '資料錯誤'
          },
          'ERRORES': {
            'alfabetica': '字母無效數據',
            'alfanumerica': '字母數字無效數據',
            'numerica': '數值無效數據',
            'email': '電子郵件無效語法',
            'vacio': '空單元格',
            'columna': '未知欄',
            'catSurvey': '未知數據',
            'repetido': '重複數據',
            'sameKey': '相同的老闆鑰匙',
            'noCeo': '找不到首席執行官',
            'bosskeyNotFnd': '老闆鍵不存在',
            'continuidad': '水平連續性',
            'nivelRepetido': '重複信息',
            'multiceo': '多位CEO',
            'age': '錯誤的出生年份',
            'seccionSinUsar': '未使用特殊部分鍵',
            'date': '日期格式無效',
            'listOption': '信息不正確',
            'dateFuture': '不允許的日期',
            'longitud_60': '超出允許的字符數',
            'minimumAge': '員工年齡低於最低年齡'
          },
          'DESCRIPCION': {
            'alfabetica': '該信息包含一個或多個無效字符。 僅字母字符（A-Z）和下一個特殊字符：[（）。 ， ： -] 被允許',
            'alfanumerica': '該信息包含一個或多個無效字符。 僅字母字符（A-Z），數字（0-9）和下一個特殊字符：[（）。 ， ： -] 被允許',
            'numerica': '該信息包含一個或多個無效字符。 僅允許使用數字字符（0-9）',
            'email': '該信息的電子郵件語法不正確（mail@domain.com）',
            'vacio': '該單元缺少信息。 此列為必填項。',
            'columna': '該列不屬於CulturalGO提供的模板',
            'catSurvey': '單元信息與平台的“人口統計”部分中輸入的任何選項都不匹配',
            'repetido': '該單元格具有來自同一列中另一個單元格的重複信息。 此列中不允許重複的數據。',
            'sameKey': '該行在此列中具有相同的信息：“僱員編號”和“直接老闆編號”，這是不允許的',
            'noCeo': '在合作者列表中找不到CEO信息，必須將其EMPLOYEE NUMBER指定為\'0\'才能繼續',
            'bosskeyNotFnd': '找不到此單元格中指定的上司密鑰與列表上的任何協作者相關聯',
            'continuidad': '此單元格中水平的連續性已中斷，水平必須連續',
            'nivelRepetido': '重複此單元格中的信息，並重複對應於上一級別的信息，這是不允許的',
            'multiceo': '發現不止一位合作者指定為CEO，文件中只允許一位合作者指定為CEO ',
            'age': '輸入的出生年份必須是四位數',
            'seccionSinUsar': '至少找到了一個未在協作者列表中使用的特殊部分鍵。 所有特殊部分的密鑰都需要由至少一個協作者使用',
            'date': '輸入的信息的日期格式不正確',
            'listOption': '輸入的信息與模板提供的任何選項都不匹配。 此單元格中只允許使用一個默認選項',
            'dateFuture': '在單元格中輸入的日期對應於當天之後的日期。 只允許輸入當前日期之前的日期',
            'longitud_60': '該信息超過了該欄允許的最大字符數（60 個字符）',
            'minimumAge': '輸入的員工年齡低於最低年齡，回答調查的最低年齡為 15 歲'
          }
        },
        'CARD_LOAD': {
          'CARGA': {
            'TITULO': '載入中',
            'INFO': '正在分析文件信息，請稍等'
          },
          'GUARDA': {
            'TITULO': '保存',
            'INFO': '將信息存儲到系統中，請保留在此屏幕中，直到完成保存過程為止'
          },
        },
        'MENSAJES': {
          'GUARDA_1': '您確認要存儲以下信息嗎？ ',
          'GUARDA_2': ' 合作者？',
          'GUARDADO': '合作者數據庫已成功存儲',
          'GUA_ERR': '存儲信息時發生錯誤。 稍後再試',
          'NODELETE':'如果電子郵件已發送給協作者，則無法刪除數據庫',
          'DELETE_1': '您是否確認刪除以下信息： ',
          'DELETE_2': ' 合作者？',
          'DEL_OK_1': '的信息 ',
          'DEL_OK_2': ' 合作者已成功刪除',
          'DEL_ERR': '刪除合作者數據庫時發生錯誤。 稍後再試',
          'DEL_ERR_EMA_SEN': '此操作不可能，因為電子郵件已發送',
          'DELFILE': '合作者數據庫文件已正確刪除',
          'EXCEL': '正在生成Excel文件，請稍等',
          'EXTMAL': '所選文件的格式不正確。 只允許上傳CulturalGO提供的模板文件',
          'NOROWS': '所選文件沒有任何記錄',
          'VACIO': '所選文件為空，或第一張表中沒有合作者信息',
          'VERSIONANTERIOR': '所選文件對應於協作者列表的先前版本，下載最新版本，上傳該文件中協作者的信息並重新上傳列表',
          'BROKERINCORRECTO': '所選文件與公司所屬經紀商版本不符，重新下載模板，上傳該文件中合作者信息，重新上傳列表',
          'BOTONES': {
            'SI': '是',
            'NO': '沒有'
          }
        },
        'EXCELINFO': {
          'HOJA': '協作者數據',
          'TITULO': '協作者數據庫',
          'AUTOR': '文化GO',
          'ASUNTO': '從平台下載'
        },
        'UPLOAD': '單擊此處瀏覽員工資料庫',
        'REMOVE': '從上傳中刪除',
        'SEND': '發送到資料庫',
        'PROCESO': {
          'STP1': '分析員工資料庫',
          'STP2': '保存員工資料庫'
        },
        'ALERT_COLAB':'一旦將此步驟標記為完成，用戶將反映在調查中',
        'MODAL_ERROR': {
          'TITULO': '在文件中發現的錯誤',
          'TOTAL_ERRORES_1': '在文件中發現的錯誤',
          'TOTAL_ERRORES_2': '在文件中發現 <b> 100 多個 </b> 錯誤',
          'INFO_1': '具體錯誤的數量和類型在下面詳細展示',
          'INFO_2': '<b> 注意：</b> 只有當文件沒有錯誤時，進程才能繼續，當關閉此窗口時，進程將重新啟動。 對文件進行必要的更正並重新加載它',
          'TABLA_RESUMEN': {
            'TIPO': '錯誤類型',
            'TOTAL': '總錯誤',
            'ACCIONES': '行動',
            'MASINFO': '更多信息',
            'VERMAS': '查看錯誤'
          },
          'TABLA_LISTA': {
            'TOTAL_1': '顯示的錯誤',
            'TOTAL_2': '錯誤未顯示',
            'INFO': '未顯示的錯誤在特性上與顯示的相似',
            'FILA': '排',
            'COLUMNA': '柱子',
            'DATO': '錯誤的數據'
          },
          'BOTONES': {
            'REGRESAR': '回去',
            'CONTINUAR': '繼續'
          }
        }
      }
    }
  }
};
